export enum TicketsActionType {
	FETCH_ALL_TICKETS = 'FETCH_ALL_TICKETS',
	STORE_ALL_TICKETS = 'STORE_ALL_TICKETS',
	ERROR_ALL_TICKETS = 'ERROR_ALL_TICKETS'
}
